export default {
    campaignReadAllBegin(state) {
        state.loading = true;
    },
  
    campaignReadAllSuccess(state, data) {
        state.loading = false;
        state.data = data.list !== undefined ? data.list : [];
        state.total = data.total !== undefined ? data.total : 0;
    },

    campaignReadAllError(state, error) {
        state.loading = false;
        state.error = error;
    },

    campaignAddBegin(state) {
        state.loading = true;
    },

    campaignAddSuccess(state) {
        state.loading = false;
    },

    campaignAddError(state, error) {
        state.loading = false;
        state.error = error;
    },

    campaignReadSuccess(state, data) {
        state.loading = false;
        state.currentCampaign = data;
    },

    campaignDetailReadBegin(state) {
        state.loading = true;
    },

    campaignDetailReadSuccess(state, data) {
        state.loading = false;
        state.detailData = data.list !== undefined ? data.list : [];
        state.detailTotal = data.total !== undefined ? data.total : 0;
    },

    campaignDetailReadError(state, error) {
        state.loading = false;
        state.error = error;
    },

    setSelectedIds(state, data) {
        state.selectedIds = data;
    },
};